import {styled} from "@mui/system";
import {ToggleButtonGroup} from "@mui/material";

export const RbToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
    '& .MuiToggleButton-root.Mui-selected': {
        backgroundColor: "transparent",
    },
}));
